export default __webpack_public_path__ + "static/media/Group9111.812b32fc.svg";